import React from "react"
import { library, config } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// icons to import
import {
  faQuoteRight,
  faArrowRight,
  faStarHalfAlt,
  faStar,
} from "@fortawesome/free-solid-svg-icons"

import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons"

import {
  faStarHalf,
  faStar as faStarReg,
} from "@fortawesome/free-regular-svg-icons"

import {
  aws,
  bootstrap,
  chartjs,
  css3,
  docker,
  express,
  gatsby,
  git,
  heroku,
  html5,
  hugo,
  illustrator,
  javascript,
  jquery,
  mongodb,
  netlify,
  node,
  npm,
  photoshop,
  postgresql,
  rails,
  react,
  redis,
  redux,
  ruby,
  sketch,
  webpack,
  yarn,
  go,
  graphql,
  tailwindcss,
} from "./devicon"

config.autoAddCss = true

library.add(
  faQuoteRight,
  faLinkedin,
  faGithub,
  faArrowRight,
  faStarHalfAlt,
  faStar,
  faStarHalf,
  faStarReg
)

const devIcons = {
  aws,
  bootstrap,
  chartjs,
  css3,
  docker,
  express,
  gatsby,
  git,
  heroku,
  html5,
  hugo,
  illustrator,
  javascript,
  jquery,
  mongodb,
  netlify,
  node,
  npm,
  photoshop,
  postgresql,
  rails,
  react,
  redis,
  redux,
  ruby,
  sketch,
  webpack,
  yarn,
  go,
  graphql,
  tailwindcss,
}

const DevIcon = props => {
  const Icon = devIcons[props.icon]
  return <Icon {...props} />
}

const Icon = props => {
  const { icon, variant = "fas", ...rest } = props
  if (variant === "dev") return <DevIcon icon={icon} {...rest} />
  else return <FontAwesomeIcon icon={[variant, icon]} {...rest} />
}

export default Icon
